import * as Sentry from '@sentry/browser';

const returnFirstArg = (x) => x;

const TOKEN = 'Xm4faXb5SijhFRLlIPnHh6MZmXMpIUHH';

export default class Service {
  constructor(api, options = {}) {
    this.api = api;
    this.api.use({
      headers: {
        'Access-Token': TOKEN,
      },
    });
    const { afterParser = returnFirstArg } = options;
    this.afterParser = afterParser;
    this.retriesLimit = options.retriesLimit;
  }

  async find(params, retries = 0) {
    try {
      const response = await this.api.get(params);
      return this.afterParser(response);
    } catch (err) {
      if (this.retriesLimit && retries < this.retriesLimit) {
        return this.find(params, retries + 1);
      }

      Sentry.captureException(err);
      throw new Error(err);
    }
  }

  update(data = {}, options = {}) {
    return this.api.post(data, options).then(this.afterParser);
  }

  modify(data = {}, options = {}) {
    return this.api.patch(data, options).then(this.afterParser);
  }

  insert(data = {}, options = {}) {
    return this.api.put(data, options).then(this.afterParser);
  }

  remove(params = {}) {
    return this.api.delete(params).then(this.afterParser);
  }
}
